export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Roman.a965aad8.woff2";